import { render, staticRenderFns } from "./DocumentTocItem.vue?vue&type=template&id=eb8b45f0&"
import script from "./DocumentTocItem.vue?vue&type=script&lang=js&"
export * from "./DocumentTocItem.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTocItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports